import type { Kiosk } from '@gozoki/api-types'
import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchCheckoutKiosks } from '../queries/checkoutKiosk.queries'

export const useCheckoutKiosks = (
  storeId: number,
  enabled = true,
): UseQueryResult<Kiosk[], unknown> =>
  useQuery({
    queryKey: ['checkout', storeId],
    queryFn: () => fetchCheckoutKiosks(storeId),
    enabled,
    refetchInterval: 5000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: 4000,
  })
